

























































































































































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import dayjs from 'dayjs'
import { MedicationInstructionPayload } from '@/api/medicationInstruction/types'
import InputGroup from '@/mixins/form/inputGroup'
import { getAllDatesOfMonth } from '@/utils/datetime'
import { DateString } from '@/types/utils'

const TODAY = dayjs()
const TODAY_OF_LAST_YEAR = TODAY.subtract(1, 'year')
const TODAY_OF_NEXT_YEAR = TODAY.add(1, 'year')

@Component({
  components: {
    TextareaInput: () => import('@/components/common/inputs/TextareaInput.vue'),
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue'),
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue'),
    TextInput: () => import('@/components/common/inputs/TextInput.vue')
  }
})
export default class InstructionInputGroup extends mixins(InputGroup) {
  @Prop(Object) inputs!: MedicationInstructionPayload
  @Prop({ type: Object, default: () => ({}) }) errorMessages!: {
    [key: string]: string
  }

  inputNextVisitYear: number | null = null
  inputNextVisitMonth: number | null = null
  inputNextVisitDay: number | null = null

  get nextVisitYearOptions() {
    const start = TODAY_OF_LAST_YEAR.year()
    const end = TODAY_OF_NEXT_YEAR.year()
    return [...new Array(end - start + 1)].map((_, i) => start + i)
  }

  get nextVisitMonthOptions() {
    if (!this.inputNextVisitYear) {
      return []
    }
    return this.generateMonthOptions(this.inputNextVisitYear)
  }

  get nextVisitDayOptions() {
    if (!this.inputNextVisitYear || !this.inputNextVisitMonth) {
      return []
    }
    return getAllDatesOfMonth(this.inputNextVisitYear, this.inputNextVisitMonth)
  }

  generateMonthOptions(selectedYear: number) {
    const lastYear = TODAY_OF_LAST_YEAR.year()
    const nextYear = TODAY_OF_NEXT_YEAR.year()
    const thisMonth = TODAY.month() + 1

    if (selectedYear === lastYear) {
      return [...new Array(12 - thisMonth)].map((_, i) => i + thisMonth + 1)
    }

    if (selectedYear === nextYear) {
      return [...new Array(thisMonth)].map((_, i) => i + 1)
    }

    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  }

  handleChangeNextVisitYear(value: number | null) {
    if (value === null) {
      this.inputNextVisitMonth = null
      this.inputNextVisitDay = null
    } else if (
      !this.inputNextVisitMonth ||
      this.nextVisitMonthOptions.indexOf(this.inputNextVisitMonth) === -1
    ) {
      this.inputNextVisitMonth = this.nextVisitMonthOptions[0]
      this.inputNextVisitDay = this.nextVisitDayOptions[0]
    } else if (
      !this.inputNextVisitDay ||
      this.nextVisitDayOptions.indexOf(this.inputNextVisitDay) === -1
    ) {
      this.inputNextVisitDay = this.nextVisitDayOptions[0]
    }

    this.$set(this.inputs, 'nextVisitDate', this.selectedNextVisitDate)
  }

  handleChangeNextVisitMonth(value: number | null) {
    if (value === null) {
      this.inputNextVisitDay = null
    } else if (
      !this.inputNextVisitDay ||
      this.nextVisitDayOptions.indexOf(this.inputNextVisitDay) === -1
    ) {
      this.inputNextVisitDay = this.nextVisitDayOptions[0]
    }

    this.$set(this.inputs, 'nextVisitDate', this.selectedNextVisitDate)
  }

  handleChangeNextVisitDay() {
    this.$set(this.inputs, 'nextVisitDate', this.selectedNextVisitDate)
  }

  get selectedNextVisitDate() {
    if (
      this.inputNextVisitYear === null ||
      this.inputNextVisitMonth === null ||
      this.inputNextVisitDay === null
    ) {
      return null
    }

    return dayjs(
      new Date(
        this.inputNextVisitYear,
        this.inputNextVisitMonth - 1,
        this.inputNextVisitDay
      )
    ).format('YYYY-MM-DD') as DateString
  }

  get instructionEfficacyDescriptionOptions() {
    return [
      { label: '全', value: 1 },
      { label: '重点', value: 2 }
    ]
  }

  get instructionUnderstandingOptions() {
    return [
      { label: '良', value: 1 },
      { label: '不良', value: 0 }
    ]
  }

  get instructionStorageStatusOptions() {
    return [
      { label: '良', value: 1 },
      { label: '不良', value: 0 }
    ]
  }

  get instructionAnotherDepartmentOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }

  get instructionConcurrentMedicationOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }

  get instructionSideEffectOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }

  get instructionHealthPreferenceOptions() {
    return [
      { label: '有', value: 1 },
      { label: '無', value: 0 }
    ]
  }

  created() {
    if (this.inputs.nextVisitDate) {
      const nextVisitDate = dayjs(this.inputs.nextVisitDate)
      this.inputNextVisitYear = nextVisitDate.year()
      this.inputNextVisitMonth = nextVisitDate.month() + 1
      this.inputNextVisitDay = nextVisitDate.date()
    }
  }
}
